import React from 'react';
import PropTypes from 'prop-types';
import { Select, Label, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';

import { __, translateCartTitle } from '../../Utils';

const Wrapper = styled.div`
  padding: ${rem(20)};
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(10)};
`;

class CartsCombinator extends React.Component {
  state = {
    selectedCart: null,
  };

  render() {
    const { carts, loading } = this.props;
    const { selectedCart } = this.state;

    const activeCart = carts.find(c => c._id === this.props.activeCart);

    if (activeCart) {
      const otherCarts = carts.filter(c => c._id !== activeCart._id);
      return (
        <Wrapper>
          <Row>
            <Label>{__('Ojednávku:')}</Label>
            <Select
              size="xs"
              disabled
              icon="arrow-down"
              iconRight
              style={{ height: '2.575rem' }}
            >
              <option value={-1} true>
                {translateCartTitle(activeCart.title)}
              </option>
            </Select>
          </Row>
          <Row>
            <Label>{__('Zlúčiť s:')}</Label>
            <Select
              size="xs"
              icon="arrow-down"
              iconRight
              style={{ height: '2.575rem' }}
              onChange={e =>
                this.setState({
                  selectedCart: e.target.value,
                })
              }
            >
              <option value={null} disabled selected={selectedCart === null}>
                {'-'}
              </option>
              {otherCarts.map(c => (
                <option value={c._id} selected={selectedCart}>
                  {translateCartTitle(c.title)}
                </option>
              ))}
            </Select>
          </Row>
          <Row>
            <Button
              loading={loading}
              onClick={() => this.props.onConfirm(activeCart._id, selectedCart)}
              primary
              disabled={selectedCart === null}
            >
              {__('Zlúčiť')}
            </Button>
          </Row>
        </Wrapper>
      );
    }

    return <div />;
  }
}

CartsCombinator.propTypes = {
  carts: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  activeCart: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

CartsCombinator.defaultProps = {
  carts: [],
  loading: false,
  activeCart: '',
};

export default CartsCombinator;



// WEBPACK FOOTER //
// ./src/Components/CartsCombinator/index.jsx